module.exports = __webpack_public_path__ + "img/a.1a21e693.jpg";